import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { Paper } from '@mui/material';
import CustomRow from './CustomRow';

const CustomTable = ({ columns, tableDetails, unique }) => (
  <Paper sx={{ width: '100 %', overflow: 'hidden' }}>
    <TableContainer sx={{ background: 'white', maxHeight: '570px', padding: '5px' }}>
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.id}
                align="left"
                sx={{ fontWeight: 'bold', color: '#22467F', minWidth: '40px', background: 'white', padding: '0.8px', '&:last-child td, &:last-child th': { border: 0 } }}
              >{column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {
            tableDetails.map((row) => (
              <CustomRow
                key={row[unique]}
                row={row}
                columns={columns}
              />
            ))
          }
        </TableBody>
      </Table>
    </TableContainer>
  </Paper>
);
export default CustomTable;
